import { ThemeConfig } from 'antd';

const filterConfig: ThemeConfig = {
  token: {
    fontFamily: 'var(--font-montserrat)',
    fontSize: 14,
    colorPrimary: '#006D67',
  },
  components: {
    Collapse: {
      headerPadding: '0',
      contentPadding: '0',
    },
  },
};

export default filterConfig;
